import { ExperimentConfig } from "./types"

/**
 * Centralized configuration for all experiments
 *
 * Add new experiments here with their variants and filters.
 */
export const EXPERIMENTS: Record<string, ExperimentConfig> = {
  "01JFXQ8ZY6WNBVP2KR3MXHQ4JT": {
    enabled: false,
    variants: [
      { id: "01JFXQ8ZY6A7N8P9Q2R5STUVWX", weight: 10 },
      { id: "01JFXQ8ZY6B9C1D3E5F7G9H2JK", weight: 90 },
    ],
    filters: {
      excludeLoggedInUsers: true,
    },
  },
}
